import { Link } from "react-router-dom";
import { products } from "../../Data/ProductData";
import PageIntro from "../../Components/modern/PageIntro";
import { Arrow, Container } from "../../Components/modern/UI";

function ProductCard({ product, index }) {
  return (
    <article className="sn-group sn-flex sn-h-full sn-flex-col sn-overflow-hidden sn-rounded-card sn-border sn-border-line sn-bg-white">
      <Link to={`/products/${product.slug}`} aria-label={`View details for ${product.title}`} className="sn-block sn-bg-sage sn-p-5">
        <img
          src={product.pic[0]}
          alt={product.imageAlt}
          width="560"
          height="420"
          loading={index < 3 ? "eager" : "lazy"}
          className="sn-mx-auto sn-aspect-[4/3] sn-h-auto sn-w-full sn-object-contain"
        />
      </Link>
      <div className="sn-flex sn-flex-1 sn-flex-col sn-p-6">
        <h2 className="sn-font-display sn-text-2xl sn-leading-snug sn-text-forest">{product.title}</h2>
        <p className="sn-mt-3 sn-text-sm sn-leading-relaxed sn-text-muted">{product.desc}</p>
        <dl className="sn-mt-6 sn-grid sn-gap-3 sn-border-y sn-border-line sn-py-5">
          {product.highlights.slice(0, 3).map((highlight) => (
            <div key={highlight} className="sn-flex sn-items-start sn-gap-3">
              <dt className="sn-mt-2 sn-h-1.5 sn-w-1.5 sn-rounded-full sn-bg-leaf"><span className="sn-sr-only">Highlight</span></dt>
              <dd className="sn-text-sm sn-font-semibold sn-text-ink">{highlight}</dd>
            </div>
          ))}
        </dl>
        <Link to={`/products/${product.slug}`} className="sn-mt-6 sn-inline-flex sn-min-h-[44px] sn-items-center sn-gap-4 sn-text-sm sn-font-semibold sn-text-forest hover:sn-text-leaf">
          View details
          <Arrow />
        </Link>
      </div>
    </article>
  );
}

function Products() {
  return (
    <>
      <PageIntro eyebrow="Products" title={<>Our Machines</>} />

      <section aria-label="Product listing" className="sn-bg-white sn-py-12 md:sn-py-16">
        <Container>
          <div className="sn-grid sn-gap-6 md:sn-grid-cols-2 xl:sn-grid-cols-3">
            {products.map((product, index) => (
              <ProductCard key={product.id} product={product} index={index} />
            ))}
          </div>
        </Container>
      </section>

      <section className="sn-border-t sn-border-line sn-py-12 md:sn-py-16">
        <Container className="sn-flex sn-flex-col sn-gap-6 md:sn-flex-row md:sn-items-center md:sn-justify-between">
          <div>
            <p className="sn-text-[11px] sn-font-bold sn-uppercase sn-tracking-[0.18em] sn-text-leaf">Need machine guidance?</p>
            <h2 className="sn-mt-3 sn-font-display sn-text-3xl sn-leading-tight sn-text-forest">Ask about the right machine for your farm context.</h2>
          </div>
          <a
            href="https://wa.me/919380226919?text=Hello%20Suryanirbhar%20Agritech%2C%20I%20would%20like%20to%20enquire%20about%20your%20products."
            target="_blank"
            rel="noopener noreferrer"
            className="sn-inline-flex sn-min-h-[48px] sn-items-center sn-justify-center sn-gap-4 sn-rounded sn-border sn-border-forest/30 sn-px-6 sn-py-3 sn-text-sm sn-font-semibold sn-text-forest sn-transition hover:sn-bg-sage"
          >
            Contact the team
            <Arrow />
          </a>
        </Container>
      </section>
    </>
  );
}

export default Products;
